// extracted by mini-css-extract-plugin
export var a = "apps-module--a--+eFiO";
export var appDescription = "apps-module--appDescription--eOYRK";
export var appIcon = "apps-module--appIcon--ymwxY";
export var appName = "apps-module--appName--eagqc";
export var li = "apps-module--li--ploOA";
export var lower = "apps-module--lower--ervbU";